import { createContext, useContext, ReactNode } from 'react';

interface URLContextType {
  fullUrl: string;
  pathname: string;
}

const URLContext = createContext<URLContextType | null>(null);

export const URLProvider = ({ 
  children, 
  fullUrl, 
  pathname 
}: { 
  children: ReactNode; 
  fullUrl: string; 
  pathname: string;
}) => {
  return (
    <URLContext.Provider value={{ fullUrl, pathname }}>
      {children}
    </URLContext.Provider>
  );
};

export const useURL = (): URLContextType => {
  const context = useContext(URLContext);
  if (!context) {
    // Fallback for client-side when context is not provided
    if (typeof window !== 'undefined') {
      return {
        fullUrl: window.location.href,
        pathname: window.location.pathname,
      };
    }
    return {
      fullUrl: '',
      pathname: '/',
    };
  }
  return context;
};
